import apiClient from './client';

export const authAPI = {
  login: async (email, password) => {
    const response = await apiClient.post('/auth/login', { email, password });
    return response.data;
  },

  register: async (userData) => {
    const response = await apiClient.post('/auth/register', userData);
    return response.data;
  },

  getCurrentUser: async () => {
    const response = await apiClient.get('/auth/me');
    return response.data;
  },

  // Change own password
  changePassword: async (currentPassword, newPassword) => {
    const response = await apiClient.post('/auth/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
    return response.data;
  },

  // Reset another user's password (Admin only)
  resetPassword: async (userId, newPassword) => {
    const response = await apiClient.post('/auth/reset-password', {
      user_id: userId,
      new_password: newPassword,
    });
    return response.data;
  },

  // Update user role (Admin only)
  updateRole: async (employeeId, newRole) => {
    const response = await apiClient.post('/auth/update-role', {
      employee_id: employeeId,
      new_role: newRole,
    });
    return response.data;
  },

  // === Системные пользователи (4 аккаунта для работы с БД) ===

  // Получить список системных пользователей
  getSystemUsers: async () => {
    const response = await apiClient.get('/auth/users');
    return response.data;
  },

  // Изменить роль системного пользователя
  updateSystemUserRole: async (userId, newRole) => {
    const response = await apiClient.post(`/auth/users/${userId}/role?new_role=${newRole}`);
    return response.data;
  },

  // === Матрица доступа к страницам ===

  // Получить матрицу доступа
  getPageAccess: async () => {
    const response = await apiClient.get('/auth/page-access');
    return response.data;
  },

  // Обновить доступ к странице для роли
  updatePageAccess: async (page, role, allowed) => {
    const response = await apiClient.post('/auth/page-access', {
      page,
      role,
      allowed,
    });
    return response.data;
  },

  // REMOVED: initPageAccess - удалено чтобы предотвратить случайный сброс матрицы

  // === Stage P2: Self-service password reset ===

  // Request password reset email
  forgotPassword: async (email) => {
    const response = await apiClient.post('/auth/forgot-password', { email });
    return response.data;
  },

  // Confirm password reset with token
  resetPasswordConfirm: async (token, newPassword) => {
    const response = await apiClient.post('/auth/reset-password-confirm', {
      token,
      new_password: newPassword,
    });
    return response.data;
  },
};
